import { useEffect, useState } from 'react';
import useApi from './useApi';

const fallback = {
  terms: { version: '1.1', effectiveDate: '2026-08-11' },
  privacy: { version: '1.1', effectiveDate: '2026-08-11' },
};

export default function useLegalVersions() {
  const { get } = useApi();
  const [versions, setVersions] = useState(fallback);

  useEffect(() => {
    get('/api/public/legal/versions').then(setVersions).catch(() => setVersions(fallback));
  }, [get]);

  return versions;
}
